import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Input,
  HostListener,
} from "@angular/core";
import { LocationType } from "../models/location-type";
import { StandardService } from "../services/standard.service";
import { Category } from "../models/category";
import { StandardType } from "../models/standardType";
import { FilteringGuide } from "../models/filteringGuide";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { FilteringEnum } from "../core/constant";
import { sortWithSelectedFirst, shouldShowSelectedDivider } from "../core/filter-utils";

@Component({
  selector: "app-filter-tags",
  templateUrl: "./filter-tags.component.html",
  styleUrls: ["./filter-tags.component.scss"],
})
export class FilterTagsComponent implements OnInit {
  isExportModalOpen:boolean = false;
  searchKey: string = "";
  isCategoryDropdownOpen: boolean = false;
  categorySearchText: string = "";
  filteredCategories: any[] = [];

  isLocationDropdownOpen: boolean = false;
  locationSearchText: string = "";
  filteredLocations: any[] = [];

  isStandardTypeDropdownOpen: boolean = false;
  StandardTypeSearchText: string = "";
  filteredStandardType: any[] = [];

  isExportCategoryDropdownOpen:boolean=false;
  isExportLocationDropdownOpen:boolean = false;
  isExportStandardTypeDropdownOpen:boolean = false;

  locationTypes: LocationType[] = [];
  categories: Category[] = [];
  standardTypes: StandardType[] = [];
  filterList: FilteringGuide[] = [];
  filteringForCheckBox: FilteringGuide[] = [];
   exportFilterList: FilteringGuide[] = [];

  @Output() messageEvent = new EventEmitter<Array<FilteringGuide>>();
  @Output() searchApplied = new EventEmitter<string>();
  @Output () exportFiltersApplied = new EventEmitter<Array<FilteringGuide>>();
  @Input() isFromLocation: boolean;
  @Input() searchKeyFromParent: string = "";
  @Input() isNrbes: boolean;
  constructor(
    private standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
  ) {}

  ngOnInit() {
    this.getMasterDataForFilteration();
    this.getAllStandardTypes();
  }

  getMasterDataForFilteration() {
    this.standardService
      .GetMasterDataForAddNrbes(
        this.cryptographyService.decryptData(this.storage.get("userRole")),
        this.cryptographyService.decryptData(this.storage.get("userId")),
      )
      .subscribe((data: any) => {
        this.categories = data.categories;
        this.locationTypes = data.locationTypes;
      });
  }

  getAllStandardTypes(): void {
    this.standardService
      .getAllStandardTypes(!this.isNrbes, this.isNrbes)
      .subscribe((data: StandardType[]) => {
        this.standardTypes = data;
      });
  }

  addFilter($event, id, filterParam, name, type) {
    this.sendAuthEvent(name, id, type, $event.checked);
    if (this.getFilter(this.isNrbes) != null) {
      this.filterList = this.getFilter(this.isNrbes);
    }
    if ($event.checked) {
      let filterGuide = this.filterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.filterList.push(guide);
      }
    } else {
      let selectedFilter = this.filterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter.ids.length == 0) {
        let i = this.filterList.findIndex((x) => x.type === filterParam);
        this.filterList.splice(i, 1);
      }
    }
    this.setFilter(this.isNrbes, this.filterList);
    this.refreshFilteredListForFilterParam(filterParam);
    // this.messageEvent.emit(this.filterList);
  }

  private setFilteredCategories(items: any[]): void {
    this.filteredCategories = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(FilteringEnum.FilterByCategory, id),
    );
  }

  private setFilteredLocations(items: any[]): void {
    this.filteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setFilteredStandardTypes(items: any[]): void {
    this.filteredStandardType = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(
        FilteringEnum.FilterByStandardType,
        id,
      ),
    );
  }

  private setExportFilteredCategories(items: any[]): void {
    this.filteredCategories = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByCategory,
        id,
      ),
    );
  }

  private setExportFilteredLocations(items: any[]): void {
    this.filteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setExportFilteredStandardTypes(items: any[]): void {
    this.filteredStandardType = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByStandardType,
        id,
      ),
    );
  }

  private refreshFilteredListForFilterParam(filterParam: number): void {
    if (
      filterParam === FilteringEnum.FilterByCategory &&
      this.isCategoryDropdownOpen
    ) {
      this.filterCategories();
    } else if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isLocationDropdownOpen
    ) {
      this.filterLocations();
    } else if (
      filterParam === FilteringEnum.FilterByStandardType &&
      this.isStandardTypeDropdownOpen
    ) {
      this.filterStandardTypes();
    }
  }

  private refreshExportFilteredListForFilterParam(filterParam: number): void {
    if (
      filterParam === FilteringEnum.FilterByCategory &&
      this.isExportCategoryDropdownOpen
    ) {
      this.setExportFilteredCategories([...this.categories]);
    } else if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isExportLocationDropdownOpen
    ) {
      this.setExportFilteredLocations([...this.locationTypes]);
    } else if (
      filterParam === FilteringEnum.FilterByStandardType &&
      this.isExportStandardTypeDropdownOpen
    ) {
      this.setExportFilteredStandardTypes([...this.standardTypes]);
    }
  }

  applyFilters() {
    this.messageEvent.emit(this.filterList);
  }

  setCheckedStateForCheckBoxes(type, id) {
    this.filteringForCheckBox = this.getFilter(this.isNrbes);
    if (this.filteringForCheckBox != null) {
      let t = this.filteringForCheckBox.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
  }

  getFilter(isNrbes: boolean) {
    switch (isNrbes) {
      case true: {
        return this.standardService.nrbesFiltrations.filterSet;
      }
      case false: {
        return this.standardService.upcomingStandardFiltration.filterSet;
      }
      default: {
        break;
      }
    }
  }

  setFilter(isNrbes: boolean, filterList: FilteringGuide[]) {
    switch (isNrbes) {
      case true: {
        return (this.standardService.nrbesFiltrations.filterSet = filterList);
      }
      case false: {
        return (this.standardService.upcomingStandardFiltration.filterSet =
          filterList);
      }
      default: {
        break;
      }
    }
  }

  async sendAuthEvent(filterName, filterID, filterType, isChecked) {
    this.standardService
      .recordSearchEvent([
        {
          eventType: "GRSFilters",
          filterName: filterName,
          filterID: filterID,
          filterType: filterType,
          isChecked: isChecked,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
      .subscribe({ next: () => void 0, error: () => void 0 });
  }

  toggleCategoryDropdown() {
    this.isStandardTypeDropdownOpen = false;
    this.isLocationDropdownOpen = false;
    this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
    if (this.isCategoryDropdownOpen) {
      this.categorySearchText = "";
      this.setFilteredCategories([...this.categories]);
    }
  }
  filterCategories() {
    const searchTerm = this.categorySearchText.toLowerCase();
    this.setFilteredCategories(
      this.categories.filter((category) =>
        category.name.toLowerCase().includes(searchTerm),
      ),
    );
  }
  getSelectedCategoriesCount(): number {
    return this.categories.filter((category) =>
      this.setCheckedStateForCheckBoxes(2, category.id),
    ).length;
  }
  closeDropdown() {
    this.isCategoryDropdownOpen = false;
  }

  toggleLocationDropdown() {
    this.isStandardTypeDropdownOpen = false;
    this.isCategoryDropdownOpen = false;
    this.isLocationDropdownOpen = !this.isLocationDropdownOpen;
    if (this.isLocationDropdownOpen) {
      this.locationSearchText = "";
      this.setFilteredLocations([...this.locationTypes]);
    }
  }

  filterLocations() {
    const searchTerm = this.locationSearchText.toLowerCase();
    this.setFilteredLocations(
      this.locationTypes.filter((location) =>
        location.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  getSelectedLocationsCount(): number {
    return this.locationTypes.filter((location) =>
      this.setCheckedStateForCheckBoxes(1, location.id),
    ).length;
  }

  closeLocationDropdown() {
    this.isLocationDropdownOpen = false;
  }

  //
  toggleStandardTypeDropdown() {
    this.isLocationDropdownOpen = false;
    this.isCategoryDropdownOpen = false;
    this.isStandardTypeDropdownOpen = !this.isStandardTypeDropdownOpen;
    if (this.isStandardTypeDropdownOpen) {
      this.StandardTypeSearchText = "";
      this.setFilteredStandardTypes([...this.standardTypes]);
    }
  }

  filterStandardTypes() {
    const searchTerm = this.StandardTypeSearchText.toLowerCase();
    this.setFilteredStandardTypes(
      this.standardTypes.filter((type) =>
        type.name.toLowerCase().includes(searchTerm),
      ),
    );
  }

  getSelectedStandardTypeCount(): number {
    return this.standardTypes.filter((type) =>
      this.setCheckedStateForCheckBoxes(3, type.id),
    ).length;
  }

  closeStandardTYpeDropdown() {
    this.isStandardTypeDropdownOpen = false;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Close category dropdown
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isCategoryDropdownOpen = false;
    }

    // Close location dropdown
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isLocationDropdownOpen = false;
    }
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isStandardTypeDropdownOpen = false;
    }
     if (!target.closest(".export-modal-filter-dropdown-wrapper")) {
      this.isExportStandardTypeDropdownOpen = false;
      this.isExportCategoryDropdownOpen = false;
      this.isExportLocationDropdownOpen = false;
    }
  }

  onSearch(key: any) {
    this.searchKey = key.value;
    this.searchApplied.emit(this.searchKey);
  }

  getSelectedItemsCount(type: "type" | "location" | "category"): any {
    let items: any[];

    let checkboxType: number;

    if (type === "type") {
      items = this.standardTypes;

      checkboxType = 3;
    } else if (type === "location") {
      items = this.locationTypes;

      checkboxType = 1;
    } else {
      // category

      items = this.categories;

      checkboxType = 2;
    }

    return items

      .filter((item) =>
        this.setCheckedStateForCheckBoxes(checkboxType, item.id),
      )

      .map((item) => item.name);
  }

  // Single display text function

  getDisplayText(type: "type" | "location" | "category"): string {
    const selected = this.getSelectedItemsCount(type);

    if (selected.length === 0) return "";

    if (selected.length === 1) return `: ${selected[0]}`;

    return ` : ${selected[0]} +${selected.length - 1}`;
  }

  showFilterClearButton(type: "type" | "location" | "category"): boolean {
    return this.getSelectedItemsCount(type).length > 0;
  }

  closeFilterDropdown(type: "type" | "location" | "category"): void {
    switch (type) {
      case "type":
        this.isStandardTypeDropdownOpen = false;
        break;
      case "location":
        this.isLocationDropdownOpen = false;
        break;
      case "category":
        this.isCategoryDropdownOpen = false;
        break;
    }
  }

  removeSelected(
    type: "type" | "location" | "category",
    event?: Event,
  ): void {
    event?.stopPropagation();
    event?.preventDefault();

    if (this.getFilter(this.isNrbes) != null) {
      this.filterList = this.getFilter(this.isNrbes);
    }

    this.closeFilterDropdown(type);

    let filterParam: number;
    if (type === "category") {
      filterParam = FilteringEnum.FilterByCategory;
      this.categorySearchText = "";
      this.setFilteredCategories([...this.categories]);
    } else if (type === "location") {
      filterParam = FilteringEnum.FilterByLocationType;
      this.locationSearchText = "";
      this.setFilteredLocations([...this.locationTypes]);
    } else {
      filterParam = FilteringEnum.FilterByStandardType;
      this.StandardTypeSearchText = "";
      this.setFilteredStandardTypes([...this.standardTypes]);
    }

    const filterGuide = this.filterList.find((i) => i.type === filterParam);
    if (filterGuide) {
      const index = this.filterList.indexOf(filterGuide);
      if (index !== -1) {
        this.filterList.splice(index, 1);
      }
    }

    this.setFilter(this.isNrbes, this.filterList);
    this.messageEvent.emit(this.filterList);
  }

  openExportModal(){
    this.isExportModalOpen = !this.isExportModalOpen
  }

   closeExportModal() {
        this.isExportModalOpen = false;
        this.isStandardTypeDropdownOpen = false;
        this.isCategoryDropdownOpen = false;
        this.isLocationDropdownOpen = false;
    }

        toggleExportDropdown(dropdownType: 'standardType' | 'category' | 'location') {
        // Close all other dropdowns first
        if (dropdownType !== 'standardType') {
            this.isExportStandardTypeDropdownOpen = false;
        }
        if (dropdownType !== 'category') {
            this.isExportCategoryDropdownOpen = false;
        }
        if (dropdownType !== 'location') {
            this.isExportLocationDropdownOpen = false;
        }

        // Toggle the requested dropdown
        switch (dropdownType) {
            case 'standardType':
                this.isExportStandardTypeDropdownOpen = !this.isExportStandardTypeDropdownOpen;
                if (this.isExportStandardTypeDropdownOpen) {
                    this.setExportFilteredStandardTypes([...this.standardTypes]);
                    
                }
                break;
            case 'category':
                this.isExportCategoryDropdownOpen = !this.isExportCategoryDropdownOpen;
                if (this.isExportCategoryDropdownOpen) {
                    this.setExportFilteredCategories([...this.categories]);
                  
                }
                break;
            case 'location':
                this.isExportLocationDropdownOpen = !this.isExportLocationDropdownOpen;
                if (this.isExportLocationDropdownOpen) {
                    this.setExportFilteredLocations([...this.locationTypes]);
                   
                }
                break;
        }
    }


     addExportFilter($event, id, filterParam, name, type) {
    if ($event.checked) {
      let filterGuide = this.exportFilterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.exportFilterList.push(guide);
      }
    } else {
      let selectedFilter = this.exportFilterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter && selectedFilter.ids.length == 0) {
        let i = this.exportFilterList.findIndex((x) => x.type === filterParam);
        if (i > -1) {
          this.exportFilterList.splice(i, 1);
        }
      }
    }
    console.log('Export Filters:', this.exportFilterList);
    this.refreshExportFilteredListForFilterParam(filterParam);
  }

  // Set checked state for export checkboxes
  setExportCheckedStateForCheckBoxes(type, id): boolean {
    if (this.exportFilterList != null && this.exportFilterList.length > 0) {
      let t = this.exportFilterList.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
    return false;
  }

  // Get export selected items count
  getExportSelectedItemsCount(type: "type" | "location" | "category"): any {
    let items: any[];
    let checkboxType: number;

    if (type === "type") {
      items = this.standardTypes;
      checkboxType = 3;
    } else if (type === "location") {
      items = this.locationTypes;
      checkboxType = 1;
    } else {
      // category
      items = this.categories;
      checkboxType = 2;
    }

    return items
      .filter((item) =>
        this.setExportCheckedStateForCheckBoxes(checkboxType, item.id),
      )
      .map((item) => item.name);
  }

    getExportDisplayText(type: "type" | "location" | "category"): string {
    const selected = this.getExportSelectedItemsCount(type);
    if (selected.length === 0) return "";
    if (selected.length === 1) return `${selected[0]}`;
    return `${selected[0]} +${selected.length - 1}`;
  }

  // Apply export filters and pass to API
  applyExportFilters() {
    this.isExportStandardTypeDropdownOpen = false;
    this.isExportCategoryDropdownOpen = false;
    this.isExportLocationDropdownOpen = false;
    this.exportFiltersApplied.emit(this.exportFilterList);

    this.closeExportModal();
  }

  showFilterDivider(items: any[], index: number, filterType: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      !!this.setCheckedStateForCheckBoxes(filterType, id),
    );
  }

  showExportFilterDivider(
    items: any[],
    index: number,
    filterType: number,
  ): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.setExportCheckedStateForCheckBoxes(filterType, id),
    );
  }

}
